var Thumbnail, m;

m = require('mithril');

Thumbnail = require('./Thumbnail');

module.exports = {
  view: function(ctrl, args) {
    var photo;
    return m('.GridView', {
      "class": args.leftAlign ? 'GridView--leftAlign' : ''
    }, [
      (function() {
        var i, len, ref, ref1, results;
        ref = args.photos;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          photo = ref[i];
          results.push(m(Thumbnail, {
            photo: photo,
            onPhotoSelect: args.onPhotoSelect,
            selectionFilter: (ref1 = args.selectionFilter) != null ? ref1 : function() {
              return false;
            }
          }));
        }
        return results;
      })()
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9HcmlkVmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy91aS9jb21wb25lbnRzL0dyaWRWaWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLENBQUEsR0FBSSxPQUFBLENBQVEsU0FBUjs7QUFDSixTQUFBLEdBQVksT0FBQSxDQUFRLGFBQVI7O0FBRVosTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7QUFDTCxRQUFBO1dBQUEsQ0FBQSxDQUFFLFdBQUYsRUFBZTtNQUNkLENBQUEsS0FBQSxDQUFBLEVBQVUsSUFBSSxDQUFDLFNBQVIsR0FBdUIscUJBQXZCLEdBQWtELEVBRDNDO0tBQWYsRUFFRzs7O0FBQ0Y7QUFBQTthQUFBLHFDQUFBOzt1QkFDQyxDQUFBLENBQUUsU0FBRixFQUFhO1lBQ1osT0FBQSxLQURZO1lBRVosYUFBQSxFQUFlLElBQUksQ0FBQyxhQUZSO1lBR1osZUFBQSxpREFBd0MsU0FBQTtxQkFBTTtZQUFOLENBSDVCO1dBQWI7QUFERDs7VUFERTtLQUZIO0VBREssQ0FEVSJ9
